<template>
  <div class="main">
    <div class="main-top">
      <div class="main-title">交易中心</div>
      <div class="main-map">
        <aMap></aMap>
      </div>
      <div class="deal-center-info">
        <deal-center-info></deal-center-info>
      </div>
    </div>
  </div>
</template>

<script>
import DealCenterInfo from "./seciton/deal-center-info.vue";
import aMap from "./components/map.vue";

export default {
  components: {
    aMap,
    DealCenterInfo,
  },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("analysis/updateHits", {
      visitlocation: "交易中心",
    });
  },
};
</script>

<style scoped lang="scss">
@import "@css/var.scss";
.main {
  width: 1200px;

  .main-title {
    font-size: 16px;
    font-weight: bold;
    position: absolute;
    left: 20px;
    top: 10px;
    z-index: 100;
  }

  .main-top {
    background-color: white;
    overflow: hidden;
    padding: 27px 0 45px;

    .main-map {
      width: 733px;
      height: 494px;
      float: left;
      overflow: hidden;
    }

    .deal-center-info {
      width: 387px;
      height: 494px;
      float: left;
      margin-left: 36px;
    }
  }
}
</style>
